<template>
  <div class="model-picker-popover" :class="{ open: modelPickerOpen }" v-show="modelPickerOpen">
    <div class="model-picker-list">
      <button
        v-for="model in models"
        :key="model"
        class="model-picker-item"
        :class="{ active: selectedModel === model }"
        type="button"
        @click="select(model)"
      >
        <span class="model-picker-item-dot" :style="{ background: dotColor(model) }"></span>
        <span class="model-picker-item-name">{{ model }}</span>
        <span class="model-picker-item-check">✓</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ModelPickerPopover',
  computed: {
    ...mapState(['modelPickerOpen', 'modelPickerTriggerRect']),
    ...mapGetters(['selectedModel', 'composerModelPresets']),
    models() { return this.composerModelPresets }
  },
  watch: {
    modelPickerOpen(val) {
      if (val) this.$nextTick(() => this.applyPosition())
    }
  },
  methods: {
    ...mapMutations(['SET_MODEL_PICKER_OPEN']),
    select(model) {
      this.$store.dispatch('selectModel', model)
      this.SET_MODEL_PICKER_OPEN(false)
    },
    dotColor(model) {
      const m = (model || '').toLowerCase()
      if (m.includes('deepseek')) return '#4e9aff'
      if (m.includes('gpt') || m.includes('openai')) return '#22c55e'
      if (m.includes('glm')) return '#7c5cfc'
      if (m.includes('kimi') || m.includes('moonshot')) return '#38c8c8'
      if (m.includes('minimax')) return '#f6c343'
      return '#a0aec0'
    },
    applyPosition() {
      const rect = this.modelPickerTriggerRect
      if (!rect || !this.$el) return
      const width = 220
      const popoverHeight = this.$el.offsetHeight || 248
      const left = Math.min(window.innerWidth - width - 16, Math.max(16, rect.left))
      const preferDownTop = rect.bottom + 8
      const preferUpTop = rect.top - popoverHeight - 8
      const canOpenDownward = preferDownTop + popoverHeight <= window.innerHeight - 12
      const openUpward = !canOpenDownward && preferUpTop >= 12
      const top = openUpward ? preferUpTop : Math.min(window.innerHeight - popoverHeight - 12, Math.max(12, preferDownTop))
      this.$el.style.left = `${left}px`
      this.$el.style.top = `${top}px`
    },
    handleGlobalClick(e) {
      if (this.modelPickerOpen && !this.$el.contains(e.target)) {
        this.SET_MODEL_PICKER_OPEN(false)
      }
    }
  },
  mounted() {
    this.$nextTick(() => { document.addEventListener('click', this.handleGlobalClick) })
    this.$nextTick(() => this.applyPosition())
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick)
  }
}
</script>
